var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.575,
    y1: 0.501,
    x2: 2.324,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40a737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cb531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.002,
    y1: 0.5,
    x2: 1.003,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.628,
    y1: 0.499,
    x2: 2.537,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.002,
    y1: 0.5,
    x2: 1.018,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.006,
    y1: 0.499,
    x2: 0.981,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c2c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#be1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#dc0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60039"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JCB",
    transform: "translate(0.343 -0.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2854",
    "data-name": "Rectangle 2854",
    width: 62,
    height: 40,
    rx: 4,
    transform: "translate(-0.343 0.207)",
    fill: "#1d5b99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "jcb-emblem-logo",
    transform: "translate(12.323 6.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8366",
    "data-name": "Path 8366",
    d: "M47.068,30.247a5.7,5.7,0,0,1-5.693,5.693H10.4V13.393A5.7,5.7,0,0,1,16.093,7.7H47.068Z",
    transform: "translate(-10.4 -7.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8367",
    "data-name": "Path 8367",
    d: "M129,75.052h2.353c.067,0,.224-.022.291-.022a1.05,1.05,0,0,0,.829-1.053,1.088,1.088,0,0,0-.829-1.053,1.184,1.184,0,0,0-.291-.022H129Z",
    transform: "translate(-102.418 -58.287)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8368",
    "data-name": "Path 8368",
    d: "M124.1,16.2a4.08,4.08,0,0,0-4.079,4.079v4.236h5.76a2.3,2.3,0,0,1,.4.022c1.3.067,2.264.74,2.264,1.905a1.906,1.906,0,0,1-1.86,1.86v.045c1.322.09,2.331.829,2.331,1.972,0,1.233-1.121,2.04-2.6,2.04H120v8.293h5.984a4.08,4.08,0,0,0,4.079-4.079V16.2Z",
    transform: "translate(-95.436 -14.295)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8369",
    "data-name": "Path 8369",
    d: "M132.183,59.686a.953.953,0,0,0-.829-.964c-.045,0-.157-.022-.224-.022H129v1.972h2.129a.625.625,0,0,0,.224-.022A.953.953,0,0,0,132.183,59.686Z",
    transform: "translate(-102.418 -47.269)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8370",
    "data-name": "Path 8370",
    d: "M23.5,16.2a4.08,4.08,0,0,0-4.079,4.079V30.343a8.066,8.066,0,0,0,3.519.919,1.952,1.952,0,0,0,2.174-2.017V24.493h3.5v4.729c0,1.838-1.143,3.34-5.02,3.34a17.206,17.206,0,0,1-4.191-.515V40.63h5.984a4.08,4.08,0,0,0,4.079-4.079V16.2Z",
    transform: "translate(-17.383 -14.295)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8371",
    "data-name": "Path 8371",
    d: "M73.879,16.2A4.08,4.08,0,0,0,69.8,20.279v5.334c1.031-.874,2.824-1.434,5.715-1.3a18.187,18.187,0,0,1,3.205.493v1.726a7.759,7.759,0,0,0-3.093-.9c-2.2-.157-3.519.919-3.519,2.8,0,1.905,1.322,2.981,3.519,2.8a8.141,8.141,0,0,0,3.093-.9v1.726a17.753,17.753,0,0,1-3.205.493c-2.891.134-4.684-.426-5.715-1.3v9.413h5.984A4.08,4.08,0,0,0,79.863,36.6V16.2Z",
    transform: "translate(-56.487 -14.295)",
    fill: "url(#linear-gradient-5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.95cf16374387db62ff16aeb8caaa71c1.svg";
export { ForwardRef as ReactComponent };